<div id="safety-app-vehicle-settings-profile" ng-controller="VehicleSettingsProfileCtrl"></div>